// Presigned-URL signature params (S3 SigV4/SigV2, CloudFront) are replayable
// download credentials. The renderer log pipe stamps full request URLs into
// error events, so scrub the signature params before events leave the browser.
// Keep the param list in sync with `isPresignedS3Url` in files/urls.ts.
const REDACTED_VALUE = 'redacted';
const SIGNED_URL_PARAM_PATTERN = /([?&](?:X-Amz-[A-Za-z-]+|AWSAccessKeyId|Signature|Policy|Key-Pair-Id)=)[^&\s"')\\]*/gi;
export function redactSignedUrlText(text) {
    return text.replace(SIGNED_URL_PARAM_PATTERN, `$1${REDACTED_VALUE}`);
}
//# sourceMappingURL=redactSignedUrl.js.map